import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournal  {
    _originalTypeClassName = "zERP.BO.GeneralJournal";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournal.translate = translateService;
}
this.GeneralJournalDetails = [];
this.Currency = new Domain.AccountingCurrency();
this.Journal = new Domain.AccountingJournal();
this.AccountingPeriod = new Domain.AccountingPeriod();
this.Entity = new Domain.AccountingBusinessEntity();
this.GeneralJournalID = null;
this.LedgerSerialNumber = null;
this.JournalSerialNumber = null;
this.LedgerIdentity = null;
this.JournalIdentity = null;
this.DatePosted = null;
this.Description = null;
this.Memo = null;
this.Debit = null;
this.Credit = null;
this.isTemporary = false;
this.RefDocumentID = null;
this.RefDocumentType = null;
this.ClonedGeneralJournalID = null;
this.Type = null;
this.DateCreated = moment().toDate();
this._key = this.GeneralJournalID = 0; 
}

static translate: TranslateService;
_key: any;
private _GeneralJournalID:any;
get GeneralJournalID(): any {
    return this._GeneralJournalID;
  }
set GeneralJournalID(value: any) {
    this._GeneralJournalID = value;
    this._key = value;
  }
LedgerSerialNumber:any;
JournalSerialNumber:any;
LedgerIdentity:any;
JournalIdentity:any;
DatePosted:any;
Description:any;
Memo:any;
Debit:any;
Credit:any;
isTemporary:any;
RefDocumentID:any;
RefDocumentType:any;
ClonedGeneralJournalID:any;
Type:any;
DateCreated:any;
GeneralJournalDetails:any;
FiscalPeriod:any;
Currency:any;
Ledger:any;
AccountingEvent:any;
Journal:any;
AccountingPeriod:any;
Entity:any;
AutoCreatedFrom:any;
CreatedByRule:any;
CanceledBy:any;
static setGeneralJournalDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.GeneralJournalDetails == null) $this.GeneralJournalDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.GeneralJournalDetails.length > 0) {
                    Domain.GeneralJournal.removeGeneralJournalDetails($this, $this.GeneralJournalDetails[0]);
                }

                Domain.GeneralJournal.addManyGeneralJournalDetails($this, copyItems);
            }
static addManyGeneralJournalDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GeneralJournal.addGeneralJournalDetails($this, items[i]);
                }
            }
static addGeneralJournalDetails = ($this, item) => {
                if ($this.GeneralJournalDetails == null) $this.GeneralJournalDetails = [];
                if (item == null || $this.GeneralJournalDetails.indexOf(item) > -1) return;
                $this.GeneralJournalDetails.push(item);
if (item.GeneralJournal != $this) {
Domain.GeneralJournalDetail.setGeneralJournal(item, $this);
}
}
static addRangeGeneralJournalDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GeneralJournal.addGeneralJournalDetails($this, item));
            }
static removeGeneralJournalDetails = ($this, item) => {
                if ($this == null || $this.GeneralJournalDetails == null || $this.GeneralJournalDetails.indexOf(item) === -1) return;
                var _index = $this.GeneralJournalDetails.indexOf(item);
                $this.GeneralJournalDetails.splice(_index, 1);
item.GeneralJournal = null;
}
static clearGeneralJournalDetails = ($this) => { $this.GeneralJournalDetails = null; }
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
}
}
static setCurrency = ($this, value) => {
var oldValue = $this.Currency;
$this.Currency = value;
if (value != null) {
}
}
static setLedger = ($this, value) => {
var oldValue = $this.Ledger;
$this.Ledger = value;
if (value != null) {
}
}
static setAccountingEvent = ($this, value) => {
var oldValue = $this.AccountingEvent;
$this.AccountingEvent = value;
if (value != null) {
}
}
static setJournal = ($this, value) => {
var oldValue = $this.Journal;
$this.Journal = value;
if (value != null) {
}
}
static setAccountingPeriod = ($this, value) => {
var oldValue = $this.AccountingPeriod;
$this.AccountingPeriod = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setAutoCreatedFrom = ($this, value) => {
var oldValue = $this.AutoCreatedFrom;
$this.AutoCreatedFrom = value;
if (value != null) {
}
}
static setCreatedByRule = ($this, value) => {
var oldValue = $this.CreatedByRule;
$this.CreatedByRule = value;
if (value != null) {
}
}
static setCanceledBy = ($this, value) => {
var oldValue = $this.CanceledBy;
$this.CanceledBy = value;
if (value != null) {
}
}

static CalculateTotalCredit($this: any): any{$this.Credit = $this?.GeneralJournalDetails?.linq?.sum((a) => a?.Credit);
return $this?.Credit;
}
static CalculateTotalDebit($this: any): any{$this.Debit = $this?.GeneralJournalDetails?.linq?.sum((a) => a?.Debit);
return $this?.Debit;
}
static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static GetTotalCreditWithCurrencySymbol($this: any): any{if ($this?.Currency != null) {return $this?.Currency?.Symbol + " " + numeral(Domain.GeneralJournal.CalculateTotalCredit($this)).format("#,##0.00");}else {return numeral(Domain.GeneralJournal.CalculateTotalCredit($this)).format("#,##0.00");}
}
static GetTotalDebitWithCurrencySymbol($this: any): any{if ($this?.Currency != null) {return $this?.Currency?.Symbol + " " + numeral(Domain.GeneralJournal.CalculateTotalDebit($this)).format("#,##0.00");}else {return numeral(Domain.GeneralJournal.CalculateTotalDebit($this)).format("#,##0.00");}
}
static ValidateDetails($this: any): any{if (CLMS.Framework.Number.Equal(() => $this.GeneralJournalDetails.length, () => 0)) {throw Error("Δεν μπορεί να αποθηκευτεί λογιστική εγγραφή χωρίς καμία συναλλαγή.");}
}
static ValidateFiscalPeriod($this: any): any{if ((new Date($this?.DatePosted).getTime()) > (new Date($this?.FiscalPeriod?.EndDate).getTime()) || (new Date($this?.DatePosted).getTime()) < (new Date($this?.FiscalPeriod?.StartDate).getTime())) {throw Error("Η ημερομηνία της εγγραφής του Ημερολογίου [" + CLMS.Framework.DateTime.ToString($this?.DatePosted) + "] δεν ανήκει στην επιλεγμένη Οικονομική Περίοδο [" + $this?.FiscalPeriod?.Name + "].");}
}
static ValidateIsTemporary($this: any): any{if ($this?.isTemporary == false) {throw Error("Η εγγραφή του Ημερολογίου έχει οριστικοποιηθεί και δε μπορεί να τροποποιηθεί.");}
}
static ValidateJournal($this: any): any{if (CLMS.Framework.Number.Equal(() => $this.Ledger.Journals.linq.count((a) => CLMS.Framework.Number.Equal(() => a.JournalID, () => $this.Journal.JournalID)), () => 0)) {throw Error("Το ημερολόγιο [" + $this?.Journal?.Name + "] που καθορίζεται στην εγγραφή του Ημερολογίου, δεν είναι έγκυρο για το Καθολικό [" + $this?.Ledger?.Name + "].");}
}
static ValidateLedger($this: any): any{if ($this?.Ledger?.DateLastUpdated != null && (new Date($this?.Ledger?.DateLastUpdated).getTime()) >= (new Date($this?.DatePosted).getTime())) {throw Error("Το Καθολικό [" + $this?.Ledger?.Name + "] έχει οριστικοποιηθεί εως [" + CLMS.Framework.DateTime.ToString($this?.Ledger?.DateLastUpdated) + "] και δε μπορούν να υποβληθούν άλλα Ημερολόγια.");}
let diff = Math.abs(Joove.Common.safeNumber($this?.Debit) - Joove.Common.safeNumber($this?.Credit));
if ($this?.Ledger?.isDoubleEntry == true && (CLMS.Framework.Number.GreaterThan(() => diff, () => 0.001))) {throw Error("Το Καθολικό [" + $this?.Ledger?.Name + "] είναι διπλογραφικό και το συνολικό ποσό πίστωσης πρέπει να ισούται με το συνολικό ποσό της χρέωσης (διαφορά: " + Joove.Common.safeNumber(diff) + ").");}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GeneralJournalID == null || $this.GeneralJournalID == 0;
            }


}